import { createFileRoute } from '@tanstack/react-router';

import { PrivacyPolicyPage } from '@/components/legal/PrivacyPolicyPage';

const PrivacyPolicy = () => {
  return <PrivacyPolicyPage />;
};

export const Route = createFileRoute('/$locale/privacy')({
  component: PrivacyPolicy,
});
